<template lang="pug">
    creators-list-modal.followers-modal(v-bind="$attrs" title="Followers" :creators="creators" emptyMessage="No followers")
        template(v-slot:list-item-decorator="{creator}")
            .followers-modal__subscription-icon(v-if="checkIsSubscriber(creator)")
                svg-icon(iconId="subscription")
</template>

<script>
import UserFollowsService from '../../services/user-follows-service'
import UserSubscribersService from '../../services/user-subscribers-service'

export default {
    name: 'followers-modal',

    props: {
        user: {
            type: Object,
        },
    },

    data() {
        return {
            creators: null,
            subscriberIds: [],
        }
    },

    methods: {
        checkIsSubscriber(creator) {
            return this.subscriberIds.includes(creator.id)
        },
    },

    async created() {
        const r = await UserFollowsService.followers(this.user?.id)
        const creators = r.data.data

        if (!this.user || this.user.owner) {
            UserSubscribersService.checkSubscribers(creators.map(c => c.id)).then(({data}) => {
                this.subscriberIds.push(...data)
                this.creators = creators
            })
        }
        else {
            this.creators = creators
        }
    },
}
</script>
